import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import { Alert, Button } from "reactstrap";
import { withRouter, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginUser } from "../../store/actions";
import { getAuthUser, getUserRole } from "helpers/permissionHelper";
import {
  RiToothLine,
  RiLock2Line,
  RiShieldCheckLine,
  RiEyeLine,
  RiEyeOffLine,
  RiKeyLine,
  RiLockUnlockLine
} from "react-icons/ri";

import oralstopLogo from "../../assets/images/logos/oralstop-logo.png";

import "./auth-custom.scss";

const LockScreen = (props) => {
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  
  const [user, setUser] = useState({
    name: "Dr. Sameer Deshmukh",
    email: "doctor@oralstop.com",
    role: "Admin"
  });

  useEffect(() => {
    const auth = getAuthUser();
    const role = getUserRole();
    if (auth?.user) {
      setUser({
        name: auth.user.name || "Dr. Sameer Deshmukh",
        email: auth.user.email || "doctor@oralstop.com",
        role: role || "Doctor"
      });
    }
  }, []);

  const handleUnlock = (e) => {
    e.preventDefault();
    if (!password) {
      setErrorMsg("Please enter your password to unlock the session.");
      return;
    }

    setIsSubmitting(true);
    setErrorMsg("");

    dispatch(
      loginUser(
        {
          email: user.email,
          password: password,
        },
        props.history
      )
    );

    setTimeout(() => {
      setIsSubmitting(false);
    }, 1200);
  };

  const getCleanDisplayName = (name) => {
    if (!name) return "User";
    const parts = name.split(" ");
    if (parts.length > 1 && (parts[0] === "Dr." || parts[0] === "Dr")) {
      return parts[1];
    }
    return parts[0];
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>Lock Screen | 909 Dental Practice Platform</title>
      </MetaTags>

      <div className="dental-auth-wrapper">
        <div className="dental-lock-card">
          {/* Top Brand Logo */}
          <div className="mb-3 text-center">
            <img src={oralstopLogo} alt="oralstop.com" height="42" className="dental-brand-logo-img" />
          </div>

          <h3 className="font-weight-bold text-dark font-size-18 mb-1">
            Session Locked
          </h3>
          <p className="text-muted font-size-12 mb-4">
            Clinical screen locked for privacy & HIPAA compliance.
          </p>

          {/* User Profile Identity with Locked Avatar */}
          <div className="p-3 bg-light rounded-4 border mb-4">
            <div className="dental-lock-avatar-wrapper">
              <div className="dental-lock-avatar">
                {user.name ? user.name.replace("Dr. ", "").charAt(0).toUpperCase() : "D"}
              </div>
              <div className="dental-lock-badge-icon">
                <RiLock2Line />
              </div>
            </div>

            <h5 className="font-weight-bold text-dark font-size-15 mb-0.5">
              {user.name}
            </h5>
            <span className="badge bg-primary text-white font-size-11 px-2.5 py-0.5 rounded-pill text-uppercase font-weight-semibold">
              {user.role}
            </span>
            <div className="text-muted font-size-12 mt-1">
              {user.email}
            </div>
          </div>

          {/* Error Alert */}
          {errorMsg && (
            <Alert color="danger" className="py-2 px-3 font-size-12 d-flex align-items-center mb-3 text-start">
              <i className="mdi mdi-alert-circle-outline me-2 font-size-15 flex-shrink-0" />
              <span>{errorMsg}</span>
            </Alert>
          )}

          {/* Password Unlock Form */}
          <form onSubmit={handleUnlock} className="text-start">
            <div className="custom-auth-group mb-3">
              <label className="custom-auth-label" htmlFor="lock-password">
                Enter Password
              </label>
              <div className="custom-input-box">
                <RiKeyLine className="input-icon-prefix" />
                <input
                  id="lock-password"
                  type={showPassword ? "text" : "password"}
                  className="form-control dental-input-field"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (errorMsg) setErrorMsg("");
                  }}
                  autoFocus
                  required
                />
                <button
                  type="button"
                  className="input-icon-suffix"
                  onClick={() => setShowPassword(!showPassword)}
                  title={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                </button>
              </div>
            </div>

            <Button
              color="primary"
              type="submit"
              disabled={isSubmitting}
              className="dental-submit-btn w-100 py-2.5"
            >
              {isSubmitting ? (
                <span className="spinner-border spinner-border-sm" />
              ) : (
                <RiLockUnlockLine className="font-size-18" />
              )}
              <span>Unlock OPD Session</span>
            </Button>
          </form>

          {/* Switch Account Footer */}
          <div className="text-center pt-3 mt-4 border-top font-size-12 text-muted">
            <span>Not {getCleanDisplayName(user.name)}? </span>
            <Link to="/logout" className="signup-link">
              Sign in with a different account
            </Link>
          </div>

          {/* Security Badge */}
          <div className="d-flex align-items-center justify-content-center gap-1 font-size-11 text-muted mt-3">
            <RiShieldCheckLine className="text-success" />
            <span>256-bit AES Encrypted Clinical Session</span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(LockScreen);
